import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect } from 'react';
// @mui
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
// routes
import { paths } from 'src/routes/paths';
// _mock
import { _roles, USER_STATUS_OPTIONS } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable, emptyRows, TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TableNoData,
    getComparator
} from 'src/components/table';

import { deleteRequest, getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import UserTableFiltersResult from './costCodes-table-filter';
import UserTableRow from './costCodes-table-row';
import TablePaginationApiBased from 'src/components/table/table-pagination-api-based-urls';
import UserTableToolbar from './costCodes-table-toolebar';
import { CostCodesCreateModal } from './cost-codes-create-modal';
import { Box } from '@mui/material';
import { LoadingScreen } from 'src/components/loading-screen';
import { applyFilter } from 'src/services/fetching';

//

// ----------------------------------------------------------------------

const STATUS_OPTIONS = [ { value: 'all', label: 'All' }, ...USER_STATUS_OPTIONS ];

const TABLE_HEAD = [
    { id: 'name', label: 'Code ' },
    { id: 'name', label: 'Description' },
    // { id: 'name', label: 'Quanitity' },
    // { id: 'name', label: 'Labour hours' },
    // { id: 'name', label: 'Labour Cost' },
    // { id: 'name', label: 'Material Cost' },
    // { id: 'name', label: 'Equipment Cost' },
    // { id: 'name', label: 'Subcontractor Cost' },
    // { id: 'name', label: 'Other Cost' },
    // { id: 'name', label: 'Total Direct Cost' },
    // { id: 'name', label: 'Direct Unit Price' },
    // { id: 'name', label: 'Markup %' },
    // { id: 'name', label: 'Markup Up/ Bid Amount' },
    // { id: 'name', label: 'Markup Up/ Bid Unit Price ' },
    // { id: 'role', label: 'Start Date', width: 180 },
    // { id: 'role', label: 'Finish Date', width: 180 },
    // { id: 'role', label: 'Duration', width: 180 },
    { id: 'status', label: 'Action', width: 50 },
    // { id: '', width: 88 },
];
const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
    active: 'all',
};

// ----------------------------------------------------------------------

export default function CostCodesTable() {

    const [ tableData, setTableData ] = useState({ data: [], pagination: {} });
    const [ loading, setLoading ] = useState(false);
    const [ selectedItem, setSelectedItem ] = useState({})
    const [ deleteLoading, setDeleteLoading ] = useState(false);

    const table = useTable();
    const settings = useSettingsContext();
    const confirm = useBoolean();
    const add = useBoolean();


    useEffect(() => {
        getCostCodes();
    }, [ table.page, table.rowsPerPage ]);

    const getCostCodes = async (page = 1) => {
        const params = `?page=${page}`;
        setLoading(true)

        const data = await getRequest(`${endpoints.admin_dashboard.teachnical_database.cost_codes.get_list}${params}`);
        if (data) {
            console.log("🚀 ~ getCostCodes ~ data:", data)
            setTableData(data || []);
        }
        setLoading(false)

    };

    const [ filters, setFilters ] = useState(defaultFilters);
    const dataFiltered = applyFilter({
        inputData: tableData.data,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });
    const denseHeight = table.dense ? 52 : 72;
    const canReset = !isEqual(defaultFilters, filters);
    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );

    const handleEditRow = (row) => {
        add.onTrue();
        setSelectedItem(row);
    }
    const deleteCallBack = () => {
        confirm.onFalse();
        getCostCodes();
    };
    const handleDeleteRow = async (id) => {
        setDeleteLoading(true);
        await deleteRequest(`${endpoints.admin_dashboard.teachnical_database.cost_codes.delete}/${id}`, deleteCallBack);
        setDeleteLoading(false);
    };

    const handleFilterStatus = useCallback(
        (event, newValue) => {
            handleFilters('status', newValue);
        },
        [ handleFilters ]
    );

    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);

    const handleclose = () => {
        add.onFalse();
        setSelectedItem({})
    }

    return (
        <>
            { loading ? (
                <Box height={ 700 }>
                    <LoadingScreen />
                </Box>
            ) : (
                <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                    <CustomBreadcrumbs
                        heading="Cost Codes"
                        links={ [
                            { name: '', href: paths.dashboard.root },

                        ] }
                        action={
                            <Button
                                onClick={ () => add.onTrue() }
                                variant="contained"
                                startIcon={ <Iconify icon="mingcute:add-line" /> }
                            >
                                Create
                            </Button>
                        }
                        sx={ {
                            mb: { xs: 3, md: 5 },
                        } }
                    />
                    <Card>

                        <UserTableToolbar
                            filters={ filters }
                            onFilters={ handleFilters }
                            //
                            roleOptions={ _roles }
                            reload={ () => getCostCodes() }
                        />
                        { canReset && (
                            <UserTableFiltersResult
                                filters={ filters }
                                onFilters={ handleFilters }
                                //
                                onResetFilters={ handleResetFilters }
                                //
                                results={ dataFiltered?.length }
                                sx={ { p: 2.5, pt: 0 } }
                            />
                        ) }
                        <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                            <TableSelectedAction
                                dense={ table.dense }
                                numSelected={ table?.selected.length }
                                rowCount={ dataFiltered?.length }
                                onSelectAllRows={ (checked) =>
                                    table.onSelectAllRows(
                                        checked,
                                        dataFiltered?.map((row) => row.id)
                                    )
                                }
                                action={
                                    <Tooltip title="Delete">
                                        <IconButton color="primary" onClick={ confirm.onTrue }>
                                            <Iconify icon="solar:trash-bin-trash-bold" />
                                        </IconButton>
                                    </Tooltip>
                                }
                            />
                            <Scrollbar>
                                <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                    <TableHeadCustom
                                        order={ table?.order }
                                        orderBy={ table?.orderBy }
                                        headLabel={ TABLE_HEAD }
                                        rowCount={ dataFiltered?.length }
                                        numSelected={ table?.selected.length }
                                        onSort={ table?.onSort }
                                        onSelectAllRows={ (checked) =>
                                            table?.onSelectAllRows(
                                                checked,
                                                dataFiltered?.map((row) => row.id)
                                            )
                                        }
                                    />
                                    <TableBody>
                                        { dataFiltered?.map((row) => (
                                            <UserTableRow
                                                key={ row.id }
                                                row={ row }
                                                selected={ table.selected.includes(row.id) }
                                                onSelectRow={ () => table.onSelectRow(row.id) }
                                                onDeleteRow={ () => handleDeleteRow(row.id) }
                                                onEditRow={ () => handleEditRow(row) }
                                            />
                                        )) }

                                        <TableEmptyRows
                                            height={ denseHeight }
                                            emptyRows={ emptyRows(table?.page, table?.rowsPerPage, tableData?.length) }
                                        />

                                        <TableNoData notFound={ notFound } />
                                    </TableBody>
                                </Table>
                            </Scrollbar>
                        </TableContainer>
                        { !notFound &&
                            <TablePaginationApiBased
                                // dense={ dense }
                                // onChangeDense={ handleDenseChange }
                                paginationLinks={ tableData } // The pagination links from the backend response
                                onPageChange={ (page) => getCostCodes(page) } // A function that fetches data based on the page number
                            />
                        }
                    </Card>
                </Container>
            ) }
            <CostCodesCreateModal
                open={ add.value }
                onClose={ handleclose }
                reload={ () => getCostCodes() }
                currentItem={ selectedItem }

            />

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            // handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------

